import { Component, HostListener } from '@angular/core';
import { PlayService } from '../../pages/play/play.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PlayComponent } from '../../pages/play/play.component';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'prompt-message',
  templateUrl: './prompt-message.component.html',
  styleUrls: ['./prompt-message.component.scss']
})

export class PromptMessageComponent extends BaseComponent {

  // public aspectRatio: any;

  constructor(
    public playIntroService: PlayService
    ) {
    super();

    // this.aspectRatio = window.innerWidth/window.innerHeight;
  }

  ngOnInit() {
    
  }
}
